<div class="p-d-flex" (mouseenter)="memberIsHovered = true" (mouseleave)="memberIsHovered = false">
    <div class="p-d-flex p-jc-between">
        <a [routerLink]="['/directory/profile', member?.id]" routerLinkActive="active" target="_blank">
            <p-avatar
                image="{{ member?.pictureAccessLink }}"
                size="large"
                label="{{ member?.pictureAccessLink ? '' : userHelper.initials(member) }}"
                shape="circle"
                styleClass="p-mr-2"
                [style]="{
                    'background-color': userHelper.getColorFromString(member?.firstName + ' ' + member?.lastName, 'lighten'),
                    color: userHelper.getColorFromString(member?.firstName + ' ' + member?.lastName, 'darken')
                }"
            >
            </p-avatar>
        </a>
        <div class="p-d-flex p-flex-column">
            <a [routerLink]="['/directory/profile', member?.id]" routerLinkActive="active" target="_blank">
                <p class="p-mb-0 member-title">
                    {{ truncateText ? (userHelper.getFullName(member, true) | truncateText : truncateLimit) : userHelper.getFullName(member, true) }}
                    <app-user-status-badge [currentUserStatusType]="member?.status"></app-user-status-badge>
                </p>
            </a>
            <p class="member-infos" *ngIf="member?.organizationName && member?.jobTitle">
                {{
                    truncateText
                        ? ('clubs.listItemUser.memberOrganizationTitle'
                          | translate : { title: member?.jobTitle, organization: member.organizationName }
                          | truncateText : truncateLimit)
                        : ('clubs.listItemUser.memberOrganizationTitle'
                          | translate : { title: member?.jobTitle, organization: member.organizationName })
                }}
            </p>
            <p class="member-infos" *ngIf="!member?.organizationName && member?.jobTitle">
                {{
                    truncateText
                        ? ('clubs.listItemUser.memberNoOrganizationTitle' | translate : { title: member?.jobTitle } | truncateText : truncateLimit)
                        : ('clubs.listItemUser.memberNoOrganizationTitle' | translate : { title: member?.jobTitle })
                }}
            </p>
            <p class="member-infos" *ngIf="member?.organizationName && !member?.jobTitle">
                {{
                    truncateText
                        ? ('clubs.listItemUser.memberOrganizationNoTitle'
                          | translate : { organization: member.organizationName }
                          | truncateText : truncateLimit)
                        : ('clubs.listItemUser.memberOrganizationNoTitle' | translate : { organization: member.organizationName })
                }}
            </p>
            <p class="member-infos" *ngIf="!member?.organizationName && !member?.jobTitle">
                {{
                    truncateText
                        ? ('clubs.listItemUser.memberNoOrganizationNoTitle' | translate | truncateText : truncateLimit)
                        : ('clubs.listItemUser.memberNoOrganizationNoTitle' | translate)
                }}
            </p>
        </div>
        <app-gear-edit-member
            *ngIf="isMemberEditable && canCurrentUserManageMember"
            [currentUserRole]="currentUserRole"
            [member]="member"
            [club]="club"
            [memberIsHovered]="memberIsHovered"
            (shouldUpdateMembers)="onUpdateMemberRole($event)"
            (shouldRemoveMember)="onRemoveMember($event)"
            class="relative-position p-d-flex"
        ></app-gear-edit-member>
    </div>
</div>
